import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Logs = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = true,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    data-test="logs-icon"
    height={height}
    width={width}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.4375 9.07031C9.4375 8.03478 10.277 7.19531 11.3125 7.19531H19.4375C20.473 7.19531 21.3125 8.03478 21.3125 9.07031V19.4453C21.3125 20.4808 20.473 21.3203 19.4375 21.3203H11.3125C10.277 21.3203 9.4375 20.4808 9.4375 19.4453V9.07031ZM11.3125 8.94531C11.2435 8.94531 11.1875 9.00128 11.1875 9.07031V19.4453C11.1875 19.5143 11.2435 19.5703 11.3125 19.5703H19.4375C19.5065 19.5703 19.5625 19.5143 19.5625 19.4453V9.07031C19.5625 9.00128 19.5065 8.94531 19.4375 8.94531H11.3125Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.0625 6.57031C7.96304 6.57031 7.86766 6.60982 7.79733 6.68015C7.72701 6.75047 7.6875 6.84586 7.6875 6.94531V17.0703C7.6875 17.1698 7.72701 17.2652 7.79733 17.3355C7.86766 17.4058 7.96304 17.4453 8.0625 17.4453H10.3125C10.7267 17.4453 11.0625 17.7811 11.0625 18.1953C11.0625 18.6095 10.7267 18.9453 10.3125 18.9453H8.0625C7.56522 18.9453 7.08831 18.7478 6.73667 18.3961C6.38504 18.0445 6.1875 17.5676 6.1875 17.0703V6.94531C6.1875 6.44803 6.38504 5.97112 6.73667 5.61949C7.08831 5.26786 7.56522 5.07031 8.0625 5.07031H15.9375C16.4348 5.07031 16.9117 5.26786 17.2633 5.61949C17.615 5.97112 17.8125 6.44803 17.8125 6.94531V8.07031C17.8125 8.48453 17.4767 8.82031 17.0625 8.82031C16.6483 8.82031 16.3125 8.48453 16.3125 8.07031V6.94531C16.3125 6.84586 16.273 6.75047 16.2027 6.68015C16.1323 6.60982 16.037 6.57031 15.9375 6.57031H8.0625Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.6875 4.32031C4.58804 4.32031 4.49266 4.35982 4.42233 4.43015C4.35201 4.50047 4.3125 4.59586 4.3125 4.69531V14.8203C4.3125 14.9198 4.35201 15.0152 4.42233 15.0855C4.49266 15.1558 4.58804 15.1953 4.6875 15.1953H6.9375C7.35171 15.1953 7.6875 15.5311 7.6875 15.9453C7.6875 16.3595 7.35171 16.6953 6.9375 16.6953H4.6875C4.19022 16.6953 3.71331 16.4978 3.36167 16.1461C3.01004 15.7945 2.8125 15.3176 2.8125 14.8203V4.69531C2.8125 4.19803 3.01004 3.72112 3.36167 3.36949C3.71331 3.01786 4.19022 2.82031 4.6875 2.82031H12.5625C13.0598 2.82031 13.5367 3.01786 13.8883 3.36949C14.24 3.72112 14.4375 4.19803 14.4375 4.69531V5.82031C14.4375 6.23453 14.1017 6.57031 13.6875 6.57031C13.2733 6.57031 12.9375 6.23453 12.9375 5.82031V4.69531C12.9375 4.59586 12.898 4.50047 12.8277 4.43015C12.7573 4.35982 12.662 4.32031 12.5625 4.32031H4.6875Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1875 11.4453C12.1875 11.0311 12.5233 10.6953 12.9375 10.6953H17.1875C17.6017 10.6953 17.9375 11.0311 17.9375 11.4453C17.9375 11.8595 17.6017 12.1953 17.1875 12.1953H12.9375C12.5233 12.1953 12.1875 11.8595 12.1875 11.4453Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3125 14.2713C12.3125 13.857 12.6483 13.5213 13.0625 13.5213H17.3125C17.7267 13.5213 18.0625 13.857 18.0625 14.2713C18.0625 14.6855 17.7267 15.0213 17.3125 15.0213H13.0625C12.6483 15.0213 12.3125 14.6855 12.3125 14.2713Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3125 17.0973C12.3125 16.6831 12.6483 16.3473 13.0625 16.3473H15.3125C15.7267 16.3473 16.0625 16.6831 16.0625 17.0973C16.0625 17.5115 15.7267 17.8473 15.3125 17.8473H13.0625C12.6483 17.8473 12.3125 17.5115 12.3125 17.0973Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
